import { FeatureService } from './../../../core/services/feature/feature.service';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { Permission, User } from './master-editar-perfil-acesso.models';
import { PermissionGroup } from './master-editar-perfil-acesso.models';
import { MasterEditarPerfilAcessoService } from './master-editar-perfil-acesso.service';
import { MasterEditarPerfilDuplicacaoComponent } from './custom-components/messagem-duplicacao/master-editar-perfil-duplicacao.component';
import { MasterEditarPerfilCancelamentoComponent } from './custom-components/mensagem-cancelamento/master-editar-perfil-cancelamento.component';
import { MasterConsultaProfileService } from '../master-consulta-perfil/master-consulta-perfil.service';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabGroup } from '@angular/material/tabs';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { ChangeDetectorRef } from '@angular/core';

enum messages {
  usersNotChoiced = 'É necessário escolher um usuário',
  nameProfileNotSet = 'É necessário escolher um nome para o perfil',
  permissionsNoSelected = 'É necessário escolher pelo menos uma permissão',
}

@Component({
  selector: 'app-master-editar-perfil-acesso',
  templateUrl: './master-editar-perfil-acesso.component.html',
  styleUrls: ['./master-editar-perfil-acesso.component.scss'],
})
export class MasterEditarPerfilAcessoComponent
  implements OnInit, AfterViewInit {
  constructor(
    private snackBarService: DialogBoxService,
    private dialogRef: MatDialogRef<MasterEditarPerfilAcessoComponent>,
    private formBuilder: FormBuilder,
    private masterEditarPerfilAcessoService: MasterEditarPerfilAcessoService,
    private dialog: MatDialog,
    private featureService:FeatureService,
    private masterConsultaPerfilService: MasterConsultaProfileService,
    private customAuthenticationService: CustomAuthenticationService,
    private changeDetector: ChangeDetectorRef
  ) { }
  user: any;
  profile;
  description;
  profileExist = false;
  form: FormGroup;
  sortedData: any;
  systemsPermissions: any;
  movementPermissions:any;
  positionPermissions:any
  otherReportPermissions:any;
  positionFilter:any;
  otherFilter:any;
  mouvementFilter:any;
  operationPermissions: any;
  reportPermissions: any;
  systemFilter: any;
  operationFilter: any;
  reportFilter: any;
  userFilter: any;
  systemPermissionsComplete: any;
  mouvementPermissionsComplete: any;
  positionPermissionsComplete:any;
  otherPermissionsComplete:any;
  operationPermissionsComplete: any;
  reportPermissionsComplete: any;
  usersComplete: any;
  optionUsersComplete: any;
  permissionGroup: PermissionGroup[];
  users = new MatTableDataSource<User>();
  InativeUsers = new Array<any>();
  originalGroupPermissionName: string;
  permissionsColumns = ['checkbox', 'name'];
  usersColumns = ['checkbox', 'name', 'login', 'profile', 'status'];
  usersConfirmationColumns = ['name', 'profile'];
  showMessageDuplicate = false;
  selectedUsers = new Array<User>();
  selectedPermissionGroups = new Array<PermissionGroup>();
  usersHaveProfile = new MatTableDataSource<User>();
  showUsersHaveProfile = false;
  clickSavePermission = 0;
  isAsc: boolean = false;
  panelOpenState;
  reportPermission:any
  showLoading: boolean = true;

  @ViewChild('sortSystemsPermissions', { static: false })
  sortSystemsPermissions: MatSort;
  @ViewChild('sortMouvementPermissions', { static: false })
  sortMouvementPermissions: MatSort;
  @ViewChild('sortPositionPermissions', { static: false })
  sortPositionPermissions: MatSort;
  @ViewChild('sortReportOtherPermissions', { static: false })
  sortReportOtherPermissions: MatSort;
  @ViewChild('sortOperationPermissions', { static: false })
  sortOperationPermissions: MatSort;
  @ViewChild('sortReportPermissions', { static: false })
  sortReportPermissions: MatSort;
  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  @ViewChild('sortUsersWithProfile', { static: false })
  sortUsersWithProfile: MatSort;

  @ViewChild('usersTabGroup', { static: false }) usersTabGroup: MatTabGroup;

  ngOnInit() {
    this.originalGroupPermissionName = this.user.profile;
      this.getPermissionGroups();
    this.getUsers();
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
  ngAfterViewInit() {
    this.usersHaveProfile.sort = this.sortUsersWithProfile;
  }

  getPermissionGroups() {
    this.showLoading = true;
    this.masterEditarPerfilAcessoService
      .getPermissionGroups({id:this.user.id})
      .subscribe(response => {
        if(response){
        this.showLoading = false;
        }        
        this.permissionGroup = response.naturalSort(['name']);
        this.mountPermission(this.permissionGroup);
        this.systemsPermissions.permissions.forEach(element=>{
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')
        })
        this.systemsPermissions = new MatTableDataSource<Permission>(
          this.systemsPermissions.permissions.naturalSort(['name']),
        );
        this.operationPermissions.permissions.forEach(element=>{
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')
        })
        this.operationPermissions = new MatTableDataSource<Permission>(
          this.operationPermissions.permissions.naturalSort(['name']),
        );
        this.reportPermissions.permissions.forEach(element=>{
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')
        })

        this.movementPermissions.data.forEach(element => {
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType');
        });
        this.positionPermissions.data.forEach(element => {
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType');
        });
        this.otherReportPermissions.data.forEach(element => {
          element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType');
        });
        this.reportPermissions = new MatTableDataSource<Permission>(
          this.reportPermissions.permissions.naturalSort(['name']),
        );
        this.systemsPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();
        this.operationPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();
        this.reportPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();

        this.movementPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();
        this.positionPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();
        this.otherReportPermissions.sortingDataAccessor = (data, sortHeaderId) =>
          data[sortHeaderId].naturalNormalize();

        this.systemsPermissions.sort = this.sortSystemsPermissions;
        this.operationPermissions.sort = this.sortOperationPermissions;
        this.reportPermissions.sort = this.sortReportPermissions;
        this.movementPermissions.sort = this.sortMouvementPermissions;
        this.positionPermissions.sort = this.sortPositionPermissions;
        this.otherReportPermissions.sort = this.sortReportOtherPermissions;

      });
  }

  mountPermission(permisssionGroup: Array<any>) {
    console.log(permisssionGroup, '0909099009');
    permisssionGroup.forEach(element => {
      if (element.name === 'Permissões de operação') {
       this.operationPermissions = new MatTableDataSource(element.permissions.naturalSort(['name']));
      }
      if (element.name === 'Permissões de relatório') {
       this.reportPermissions = new MatTableDataSource(element.permissions.naturalSort(['name']));
        this.reportPermission = element.permissions.filter(p => p.name ==='Relatórios');
              
      }
      if (element.name === 'Permissões de sistema') {
       this.systemsPermissions = new MatTableDataSource(element.permissions.naturalSort(['name']));
      }
      if (element.name === 'Relatorios') {
        this.movementPermissions = new MatTableDataSource(element.permissions.filter(p => p.name.startsWith('MOVEMENT')).naturalSort(['name']));
        this.positionPermissions = new MatTableDataSource(element.permissions.filter(p => p.name.startsWith('POSICAO') || p.name.startsWith('POSITION')).naturalSort(['name']));
        this.otherReportPermissions = new MatTableDataSource(element.permissions.filter(p => p.name.startsWith('OTHER')).naturalSort(['name']));
      }
    });
    const desiredOrder = ['Permissões de sistema', 'Permissões de operação', 'Permissões de relatório',"Relatorios"];
      if (permisssionGroup) {
        permisssionGroup.sort((a, b) => {
          const indexA = desiredOrder.indexOf(a.name);
          const indexB = desiredOrder.indexOf(b.name);
          return indexA - indexB;
        });
      }
  }
  validateCheckedItems(): boolean {
    let isValid : boolean =false 
    const movementsValid = this.movementPermissions?.data?.some(p =>  p.checked === true || p.checked === "true") ?? false;
    const positionsValid = this.positionPermissions?.data?.some(p =>  p.checked === true || p.checked === "true") ?? false;
    const reportsValid = this.otherReportPermissions?.data?.some(p =>  p.checked === true || p.checked === "true") ?? false;
    const reportPermission = this.reportPermission?.some(p =>  p.checked === true || p.checked === "true") ?? false;
    if(!reportPermission || (reportPermission && (movementsValid || positionsValid || reportsValid))){
      isValid =true
    } else{
      isValid=false
    }

    return isValid
  }
  getUsers() {
    let payload = {id:this.user.id};
    return this.masterEditarPerfilAcessoService
      .getUsers(payload)
      .subscribe(data => {
        const users = data
          .filter(element => {
            return (
              element.status !== 'Inativo' &&
              !this.hasProfile(element.profile.name)
            );
          })
          .naturalSort(['name']);
        this.getSelectedUsers(users);

        this.users = new MatTableDataSource<User>(users.naturalSort(['name']));
        this.users.sortingDataAccessor = (dt, head) => {
          if (head == 'profile') {
            return dt[head]['name'].naturalNormalize();
          }
          return dt[head].naturalNormalize();
        };

        this.users.sort = this.sortUsers;
      });
  }

  hasProfile(profile) {
    return this.isMasterCliente(profile) || this.isMasterBO(profile);
  }

  isMasterBO(profile) {
    if (profile === 'Master Backoffice' || profile === 'Master BO') {
      return true;
    }
  }
  isMasterCliente(profile) {
    if (profile === 'Master Cliente') {
      return true;
    }
  }

  getSelectedUsers(users: Array<any>) {
    if (users.length > 0) {
      users.forEach(element => {
        if (JSON.parse(element.checked) === true) {
          this.selectedUsers.push(element);
        }
      });
    }
  }

  removeInactiveUsers(arr: Array<any>) {
    const users = new Array<any>();

    arr.forEach(element => {
      if (element.status !== 'Inativo') {
        users.push(element);
      }
    });
    return users;
  }

  isAllSelected(arr) {
    let numSelected = 0;
    if (arr !== null) {
      arr.forEach(elemeent => {
        if (JSON.parse(elemeent.checked) === true) {
          numSelected++;
        }
      });
      const numRows = arr.length;
      return numSelected == numRows;
    }
  }

  numSelected(arr) {
    let numSelected = 0;
    if (arr !== null) {
      arr.forEach(elemeent => {
        if (JSON.parse(elemeent.checked) === true) {
          numSelected++;
        }
      });
    }

    return numSelected;
  }
  sumReportsSelected(arr1,arr2,arr3) {
    let combinedReportsArray = [...(arr1 || []), ...(arr2 || []), ...(arr3 || [])];
    let len = combinedReportsArray.length
    let numSelected = 0;
    if (combinedReportsArray !== null) {
      combinedReportsArray.forEach(elemeent => {
        if (JSON.parse(elemeent.checked) === true) {
          numSelected++;
        }
      });
    }
    let str = numSelected + "/"+len
    return str
  }

  hasValue(arr) {
    if (arr !== null) {
      const result = arr.some(element => JSON.parse(element.checked) == true);
      return result;
    }
  }

  masterToggle(arr, $event) {
    if (arr !== null) {
      arr.forEach((row, i) => {
        if (row.name === 'Relatórios' || row.name === 'Reports') {
          this.onRelatoriosSelectionChanged($event.checked);
        }
        return (arr[i].checked = $event.checked);

      });
    }
  }

  isSelected(row) {
    const isSelected = JSON.parse(row.checked);
    // if (JSON.parse(row.checked)) {
    //   return true;
    // }
    // return false;
    return isSelected;
  }

  toggle(arr, row, $event) {
    const indexSelected = arr.indexOf(row);
    if (indexSelected > -1) {
      arr[indexSelected].checked = $event.checked + '';
    }
    if (row.name === 'Relatórios'  ||row.name ==='Reports') {
      this.onRelatoriosSelectionChanged($event.checked);
    }
    this.checkRelatoriosSelection();

  }
  onRelatoriosSelectionChanged(isSelected: boolean) {
    if (!isSelected) {
      this.clearAllReportPermissions();
    }
  }
  clearAllReportPermissions() {
    // Helper function to uncheck permissions
    const uncheckPermissions = (permissions) => {
      if (permissions?.data) {
        permissions.data.forEach(p => p.checked = 'false');
        // Update the view
        permissions.data = [...permissions.data];
      }
    };
  
    // Uncheck all report permissions
    uncheckPermissions(this.movementPermissions);
    uncheckPermissions(this.positionPermissions);
    uncheckPermissions(this.otherReportPermissions);
  
    // Force change detection
    this.changeDetector.detectChanges();
  }
  setUsers(arr, row, $event) {
    this.toggle(arr, row, $event);
    const indexSelected = this.selectedUsers.indexOf(row);
    if (indexSelected === -1 && $event.checked) {
      this.selectedUsers.push(row);
    } else {
      this.selectedUsers.splice(indexSelected, 1);
      // }
    }
    this.usersHaveProfile.data = this.selectedUsers.naturalSort(['name']);
  }
  filterSystemPermissions(event: Event) {
    this.systemsPermissions.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.systemFilter = (event.target as HTMLInputElement).value;
    this.systemsPermissions.filter = this.systemFilter;

    if (this.systemFilter.length > 0 && this.systemFilter.length % 2 == 0) {
      this.systemPermissionsComplete = this.systemsPermissions.filteredData;
    } else if (this.systemFilter.length == 0) {
      this.systemPermissionsComplete = [];
    }
  }
  filterMouvementPermissions(event: Event) {
    this.movementPermissions.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.mouvementFilter = (event.target as HTMLInputElement).value;
    this.movementPermissions.filter = this.mouvementFilter.trim().toLowerCase();

    if (this.mouvementFilter.length > 0 && this.mouvementFilter.length % 2 == 0) {
      this.mouvementPermissionsComplete = this.movementPermissions.filteredData;
    } else if (this.mouvementFilter.length == 0) {
      this.mouvementPermissionsComplete = [];
    }
  }

  filterOperationPermissions(event: Event) {
    this.operationPermissions.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.operationFilter = (event.target as HTMLInputElement).value;
    this.operationPermissions.filter = this.operationFilter;

    if (
      this.operationFilter.length > 0 &&
      this.operationFilter.length % 2 == 0
    ) {
      this.operationPermissionsComplete = this.operationPermissions.filteredData;
    } else if (this.operationFilter.length == 0) {
      this.operationPermissionsComplete = [];
    }
  }

  filterReportPermissions(event: Event) {
    this.reportPermissions.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.reportFilter = (event.target as HTMLInputElement).value;
    this.reportPermissions.filter = this.reportFilter;

    if (this.reportFilter.length > 0 && this.reportFilter.length % 2 == 0) {
      this.reportPermissionsComplete = this.reportPermissions.filteredData;
    } else if (this.reportFilter.length == 0) {
      this.reportPermissionsComplete = [];
    }
  }
  filterPositionPermissions(event: Event) {
    this.positionPermissions.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.positionFilter = (event.target as HTMLInputElement).value;
    this.positionPermissions.filter = this.positionFilter.trim().toLowerCase();

    if (this.positionFilter.length > 0 && this.positionFilter.length % 2 == 0) {
      this.positionPermissionsComplete = this.positionPermissions.filteredData;
    } else if (this.positionFilter.length == 0) {
      this.positionPermissionsComplete = [];
    }
  }
  filterOtherPermissions(event: Event) {
    this.otherReportPermissions.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    };
    this.otherFilter = (event.target as HTMLInputElement).value;
    this.otherReportPermissions.filter = this.otherFilter.trim().toLowerCase();

    if (this.otherFilter.length > 0 && this.otherFilter.length % 2 == 0) {
      this.otherPermissionsComplete = this.otherReportPermissions.filteredData;
    } else if (this.otherFilter.length == 0) {
      this.otherPermissionsComplete = [];
    }
  }
  getLength(arr: Array<any>) {
    if (arr !== null && arr !== undefined) {
      return arr.length;
    }
    return 0;
  }
  filterUsers() {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = '';
      }
      return data.name.naturalNormalize().includes(filter.naturalNormalize());
    };
    this.userFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.userFilter;

    this.optionUsersComplete = this.users.filteredData;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.userFilter.length == 0) {
      this.usersComplete = [];
      this.optionUsersComplete = [];
    }
  }

  closeDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    this.dialog
      .open(MasterEditarPerfilCancelamentoComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close(true);
        }
      });
  }
  savePermission() {
    //Verifica se o nome do perfil foi alterado.
    if (this.form.controls['name'].value !== this.originalGroupPermissionName) {
      // verifica se o novo nome dado ao perfil já existe
      this.masterEditarPerfilAcessoService
        .verifyProfile(this.form.controls['name'].value.trim())
        .subscribe(response => {
          if (response.exists) {
            this.showMessageProfileDuplicate(true);
          } else {
            this.editProfile();
          }
        });
    } else {
      this.editProfile();
    }
  }

  editProfile() {
    this.showMessageProfileDuplicate(false);
    //verifica se os usuários relacionados ao perfil já possuíam outro Perfil
    if (this.selectedUsers.length > 0) {
      const usersWithProfiles = this.getUsersWithProfile(this.selectedUsers);
      this.usersHaveProfile = new MatTableDataSource<User>(
        usersWithProfiles.naturalSort(['name']),
      );
      this.usersHaveProfile.sortingDataAccessor = (dt, head) => {
        if (head == 'profile') {
          return dt[head]['name'].naturalNormalize();
        }
        return dt[head].naturalNormalize();
      };

      this.usersHaveProfile.sort = this.sortUsersWithProfile;

      if (this.usersHaveProfile.data.length > 0) {
        this.showUsersHaveProfile = true;
        this.clickSavePermission++;
      }
      if (
        this.clickSavePermission > 1 ||
        this.selectedUsers.every(element => element.profile.name === 'Nenhum')
      ) {
        this.openDialogDuplicationProfile();
      }
    } else {
      this.openDialogDuplicationProfile();
    }
  }

  sortData(columnName: string) {
    this.isAsc = !this.isAsc;
    if (this.isAsc) {
      if (columnName === 'profile') {
        this.usersHaveProfile.data.sort((a, b) => {
          return a[columnName].name.naturalNormalize() >
            b[columnName].name.naturalNormalize()
            ? 1
            : -1;
        })
      } else {
        this.usersHaveProfile.data = this.usersHaveProfile.data
          .naturalSort([columnName])
          .reverse();
      }
    } else {
      if (columnName === 'profile') {
        this.usersHaveProfile.data.sort((a, b) => {
          return a[columnName].name.naturalNormalize() >
            b[columnName].name.naturalNormalize()
            ? 1
            : -1;
        });
      } else {
        this.usersHaveProfile.data = this.usersHaveProfile.data.naturalSort([
          columnName,
        ]);
      }
    }
  }

  hasUsersWithProfile() {
    if (this.showUsersHaveProfile && this.usersHaveProfile.data.length > 0) {
      return true;
    }
    return false;
  }

  getUsersWithProfile(arr: Array<any>) {
    let usersWithProfiles = new Array<any>();
    if (arr) {
      arr.forEach(element => {
        if (element.profile.name !== 'Nenhum') {
          usersWithProfiles.push(element);
        }
      });
    }
    return usersWithProfiles;
  }

  openDialogDuplicationProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '191px';
    dialogConfig.width = '70vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.id = 'confirm-box-create-user';

    const dialogRef = this.dialog.open(
      MasterEditarPerfilDuplicacaoComponent,
      dialogConfig,
    );
    dialogRef.componentInstance.users = this.mountUsers();
    dialogRef.componentInstance.permissionGroups = this.remountPermissions();
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }

  mountUsers() {
    const users = new Array<any>();
    this.selectedUsers.forEach(element => {
      users.push({ id: element.id });
    });
    const data = {
      profile_id: this.user.id,
      users: users,
    };
    return data;
  }
  remountPermissions() {
    const permissions = new Array<any>();

    console.log(this.systemsPermissions, '----', this.operationPermissions);

    this.systemsPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    this.operationPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    this.reportPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    this.movementPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    this.positionPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    this.otherReportPermissions.data.forEach(element => {
      if (JSON.parse(element.checked)) {
        permissions.push({ id: element.id });
      }
    });
    const permissionsGroups = {
      id: this.user.id,
      profile: this.form.controls['name'].value
        ? this.form.controls['name'].value
        : this.originalGroupPermissionName,
      description: this.form.controls['description'].value,
      permissions: permissions,
    };
    return permissionsGroups;
  }

  showMessageProfileDuplicate(showMessage: boolean) {
    this.showMessageDuplicate = showMessage;
  }

  goToNextTabIndex() {
    //this.form.controls['name'].value
    let warnPerm : string;
    let  nameProfileNotSetMsg =  this.featureService.translatorService
    .translateEnumItem(
      messages.nameProfileNotSet,
      'messages'
    )
    this.featureService.translatorService.
    getMessage('Selecione ao menos 1 relatório')
    .subscribe(
      data=>warnPerm=data
    )
    const isValid = this.validateCheckedItems();
    if (!isValid) {
      warnPerm.showWarn();
      return;
    }
    if ((!this.form.controls['name'].value) || (this.form.controls['name'].value.trim().length === 0)) {
      this.snackBarService.snackbarUtil.showWarn(nameProfileNotSetMsg);
      return;
    }
    if (!this.usersTabGroup || !(this.usersTabGroup instanceof MatTabGroup))
      return;
    const tabCount = this.usersTabGroup._tabs.length;
    this.usersTabGroup.selectedIndex =
      (this.usersTabGroup.selectedIndex + 1) % tabCount;
  }
  checkRelatoriosSelection() {
    this.changeDetector.detectChanges();
  }
  hasRelatoriosPermissionSelected(): boolean {
    if (!this.reportPermissions?.data) return false;

    const relatoriosPermission = this.reportPermissions?.data?.find(permission => 
      permission.name === 'Relatórios' || permission.name ==='Reports'
    );
    
    return relatoriosPermission && this.isSelected(relatoriosPermission);
  }
  hasPermission() {
    if (
      this.customAuthenticationService.hasPermission(
        'Editar perfil de acesso',
      ) ||
      this.customAuthenticationService.hasPermission('Master cliente') ||
      this.customAuthenticationService.hasPermission('Master Backoffice')
    ) {
      return true;
    } else {
      return false;
    }
  }
}
